import { render } from "./UndergroundNpc4.vue?vue&type=template&id=153180e8&scoped=true"
import script from "./UndergroundNpc4.vue?vue&type=script&lang=js"
export * from "./UndergroundNpc4.vue?vue&type=script&lang=js"

import "./UndergroundNpc4.vue?vue&type=style&index=0&id=153180e8&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153180e8"]])

export default __exports__